'use client';
import { useState, useEffect } from 'react';
import { Language, Translations, getTranslations } from '@/lib/i18n';

export function useMergedTranslations(language: Language): Translations {
  const [merged, setMerged] = useState<Translations>(() => getTranslations(language));

  useEffect(() => {
    const base = getTranslations(language);
    setMerged(base);

    const fetchOverrides = async () => {
      try {
        const response = await fetch(`/api/index.php?route=translations&lang=${language}`);
        const result = await response.json();
        if (result.success && result.data && typeof result.data === 'object') {
          setMerged({ ...base, ...result.data });
        }
      } catch {
        // Keep base translations on error
      }
    };

    fetchOverrides();
  }, [language]);

  return merged;
}
